export default __webpack_public_path__ + "static/media/garage1.92714922.png";